<script>
    export let route;
    export let text;
    export let localisation;

    localisation = localisation === undefined ? "Accueil" : localisation

    $:cible = text.toLowerCase() === localisation.toLowerCase() ? "cible" : "";

    function updateNav(){
        localisation = text.toLowerCase();
    }
</script>

<a href="./#/{route}" on:click={updateNav}><li class="{cible}">{text}</li></a>

<style>

    .cible{
        color:rgb(83,70,102);
        border-bottom: 1px solid black;
    }

    a {
        /* color: rgb(0,100,200); */
        text-decoration: none;
    }

    a:hover {
        text-decoration: none;
    }

    li{
        color: rgb(125,125,125);
        font-size: 21px;
    }

    li:hover{
        border-bottom: 1px solid black;
	    color: rgb(83,70,102);
	    font-style: italic;
    }
</style>